import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { IAuthUser } from '@eai-tdv/core/models';
import { EnvironmentService } from '@eai-tdv/core/services/environment';
import { TranslocoRootModule } from '@eai-tdv/core/transloco';

import { IconComponent } from '@eai-tdv/shared/icon';
import {
  IconSvgLearningComponent,
  IconSvgSwitchComponent,
} from '@eai-tdv/shared/icon-svg';
import { ThemeSwitcherComponent } from '@eai-tdv/shared/theme-switcher';

import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component';
import { TdvAuthProfileUserNamePipe } from '../../../../shared/pipes/list/profile-user-name.pipe';
import { AuthUserFacadeService } from '../../../services/auth-user-facade.service';
import { AuthUserStateService } from '../../../services/auth-user-state.service';
import { NavigationWebService } from '../../../services/navigation.service';
import { SubscriptionsService } from '../../../services/subscriptions.service';

@Component({
  selector: 'tdv-profile-tooltip',
  imports: [
    NgIf,
    IconComponent,
    AvatarComponent,
    TranslocoRootModule,
    ThemeSwitcherComponent,
    IconSvgLearningComponent,
    IconSvgSwitchComponent,
    TdvAuthProfileUserNamePipe,
  ],
  templateUrl: './profile-tooltip.component.html',
  styleUrls: ['./profile-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileTootilpComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public readonly subscriptionsS = inject(SubscriptionsService);

  @Output() closeMe = new EventEmitter<void>();
  public authUserSgnl = signal<IAuthUser | null>(null);

  isLocalDev = EnvironmentService.isLocal;

  constructor(
    private authUserFacadeS: AuthUserFacadeService,
    public authUserStateS: AuthUserStateService,
    private navigationService: NavigationWebService,
  ) {}

  ngOnInit(): void {
    this.authUserFacadeS
      .selectAuthProfile()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        this.authUserSgnl.set(user);
      });
  }

  public redirectToProfile(): void {
    this.closeMe.emit();
    this.navigationService.goToProfilePersonal();
  }

  public redirectToTrainingResources(): void {
    this.closeMe.emit();
    this.navigationService.goToProfileTrainingResources();
  }

  public logOut(): void {
    this.authUserFacadeS.onLogoutFlow();
  }

  public onSwitchProfile(): void {
    this.closeMe.emit();
    this.navigationService.goToSwitchProfile();
  }
}
